export const shouldAllowImporterNavigation = ({super_user, importer_enabled}) => {
    return super_user || importer_enabled;
}